/**
 * What the safety board asks its page to open, and the reports this page
 * filed. Imports nothing: the shell reaches it on every screen.
 */

export type HazardAct = "score" | "controls" | "accept" | "close";

export type SafetyOpen =
  | { kind: "file"; hazard: string | null }
  | { kind: "report"; ref: string }
  | { kind: "raise" }
  | { kind: "hazard"; ref: string; act: HazardAct; id?: string };

/** What the engine's SMS_HOST slot calls (generated.ts, beside riskBand). */
export interface SmsHost {
  fileReport(o: { hazard: string | null }): void;
  openReport(ref: string): void;
  raiseHazard(): void;
  hazard(ref: string, act: string): void;
}

export const HAZARD_ACTS: readonly HazardAct[] = ["score", "controls", "accept", "close"];

/**
 * A report filed from this page, by reference. Someone who may file but not
 * read reports can still open what they filed, as far as they filed it.
 */
export interface FiledHere {
  id: string;
  reference: string;
  title: string;
  confidentiality: string;
  note: string;
  reportedAt: string;
}

const filed = new Map<string, FiledHere>();

export function rememberFiled(f: FiledHere): void {
  filed.set(f.reference, f);
}

export const filedHere = (reference: string): FiledHere | undefined => filed.get(reference);
